export default __webpack_public_path__ + "static/media/3.15d5cdfe.jpg";